import util from '../util';

export const CAR_LIST = 'CAR_LIST';
export const FILTER_CARS = 'FILTER_CARS';

export const CAR_LIST_REQUEST = util.requestType(CAR_LIST);
export const CAR_LIST_SUCCESS = util.successType(CAR_LIST);
export const CAR_LIST_FAILURE = util.failureType(CAR_LIST);

export const FILTER_CARS_REQUEST = util.requestType(FILTER_CARS);
export const FILTER_CARS_SUCCESS = util.successType(FILTER_CARS);
export const FILTER_CARS_FAILURE = util.failureType(FILTER_CARS);
